var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":""}},[_c('v-container',[_c('line-chart',{attrs:{"chart-data":_vm.datacollection,"options":_vm.options}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }